import { z } from 'zod';

/** The most candidates one request may name per kind; a request naming none judges the whole fleet, which is the same order of size. */
export const ELIGIBILITY_CANDIDATE_CAP = 300;

const isoInstant = z.iso.datetime({ offset: true });
const candidateIds = z.array(z.uuid()).max(ELIGIBILITY_CANDIDATE_CAP);

/**
 * `POST /dispatch/eligibility` (gitaumoses4/chukua#49): who could run this job in this window. A list left out means every truck, active
 * trailer or driver who has not left; an empty list means none of that kind. `pairing` also judges one truck with its trailer and driver together.
 */
export const eligibilityRequestSchema = z
  .object({
    jobId: z.uuid(),
    /** The trip being crewed: overrides granted on it (gitaumoses4/chukua#51) stand in for the blocks they cover. Left out, nothing is overridden. */
    tripId: z.uuid().optional(),
    originZoneCode: z.string().trim().min(1).max(32),
    destinationZoneCode: z.string().trim().min(1).max(32),
    windowStart: isoInstant.transform((value) => new Date(value)),
    windowEnd: isoInstant.transform((value) => new Date(value)),
    pickup: z.object({ zoneCode: z.string().trim().min(1).max(32), at: isoInstant.transform((value) => new Date(value)) }).optional(),
    truckIds: candidateIds.optional(),
    trailerIds: candidateIds.optional(),
    driverIds: candidateIds.optional(),
    pairing: z.object({ truckId: z.uuid(), trailerId: z.uuid().optional(), driverId: z.uuid().optional() }).optional(),
  })
  .refine((input) => input.windowEnd > input.windowStart, { message: 'The window must end after it starts', path: ['windowEnd'] });
export type EligibilityRequest = z.output<typeof eligibilityRequestSchema>;
